import { assertNever } from 'owa-assert';
import { AttachmentFolderPickerError } from '../store/schema/AttachmentFolderPickerError';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import { getStore } from '../store/store';

export function isAnyError(): boolean {
    return getStore().error !== AttachmentFolderPickerError.None;
}

export function getErrorString(): string | null {
    const error = getStore().error;

    switch (error) {
        case AttachmentFolderPickerError.UnableToLoadDefaultAttachmentFolder:
            return getOwaCommonStrings().failedToLoadDefaultUploadFolderErrorText;
        case AttachmentFolderPickerError.None:
            return null;
        default:
            return assertNever(error);
    }
}
